module.exports = __webpack_public_path__ + "assets/img/str-release.555f9094.png";